module.exports = __webpack_public_path__ + "static/media/li-icon-mobile.aed7c08d.svg";